import React from 'react'
import { Step } from 'react-joyride'

import CloseButton from '../CloseButton/CloseButton'
import PrimaryButton from '../PrimaryButton/PrimaryButton'
import TutorialPagination from '../TutorialPagination/TutorialPagination'
import RobotInFrameIcon from './RobotInFrameIcon'
import slidesData from '../TutorialSettingsProvider/tutorial-settings-constants'
import Spacer from '../../common/spacer/Spacer'
import { tutorialDataTestIds } from '../mocks/tutorial-mocks'
import { TutorialElementProps } from '../Tutorial/Tutorial'

import { TooltipProps } from '../TutorialTooltip/TutorialTooltip'

import styles from './Intro.module.scss'

type IntroProps = {
  step: Step
  closeProps: TutorialElementProps
  tooltipProps: TooltipProps
  primaryProps: TutorialElementProps
  index: number
  size: number
}

const Intro = ({
  tooltipProps,
  closeProps,
  step,
  primaryProps,
  index = 0,
  size = 0,
}: IntroProps) => (
  <div className={styles.introModal} {...tooltipProps}>
    <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
      <CloseButton closeProps={closeProps} iconSize="big" />
    </div>
    <div className={styles.contentWrapper}>
      <div className={styles.contentLeft}>
        <p className={styles.welcomeText}>{slidesData.intro.welcomeText}</p>
        <Spacer style={{ width: '100%', height: '13px' }} />
        <div className={styles.stepContent}>{step.content}</div>
        <Spacer style={{ width: '100%', height: '26px' }} />
        <PrimaryButton
          primaryProps={primaryProps}
          className={styles.primaryButton}
        />
        <Spacer style={{ width: '100%', height: '26px' }} />
        <TutorialPagination activeItemIndex={index} size={size} />
      </div>
      <div
        className={styles.contentRight}
        data-testid={tutorialDataTestIds.robotInFrameIcon}
      >
        <RobotInFrameIcon />
      </div>
    </div>
  </div>
)

export default Intro
